import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: {
    resource: {
      resources,
      companyResources,
      userResources,
      refreshFile,
      updateUserResource,
    }
  },
} = config

const getUrlWithUserId = (url, userId) => url.replace(':userId', userId)

const getUrlWithResourceId = (url, resourceId) => url.replace(':resourceId', resourceId)

const uploadFiles = (data) => axios.post(resources, data, { headers: getHeaders(true) })

const pluginGetResources = (params) => axios.get(companyResources, { headers: getHeaders(true), params })

const pluginGetSharedFiles = (userId, params) => axios.get(getUrlWithUserId(userResources, userId), { headers: getHeaders(true), params })

const refreshFileUrls = (resourceId, params) => axios.get(getUrlWithResourceId(refreshFile, resourceId), { headers: getHeaders(true), params })

const updateFileName = (fileId, data) => axios.put(getUrlWithResourceId(updateUserResource, fileId), data, { headers: getHeaders(true) })

export default { uploadFiles, pluginGetResources, pluginGetSharedFiles, refreshFileUrls, updateFileName }
